var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrapper",on:{"click":_vm.click}},[_c('svg',{staticClass:"icon",style:({color: _vm.color,width:_vm.size+'px',height:_vm.size+'px'}),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})])])}
var staticRenderFns = []

export { render, staticRenderFns }